// src/services/produtos/ProdutoService.js
import { fetchData, postData, putData } from '../Api';

export const obterProdutos = () => fetchData('/Produto', { listarInativos: true });

export const obterProdutosFavoritos = () => fetchData('/Produto/Favoritos', { listarInativos: true });

export const adicionarProduto = (produto) => postData('/Produto', produto);

export const atualizarProduto = (produto) => putData('/Produto', produto);

export const alterarFavorito = (produtoId, favorito) =>
    putData(`/Produto/AlteraFavorito?produtoId=${produtoId}&favorito=${favorito}`);

export const alterarVendeAppProduto = (produtoId, vendeApp) =>
    putData(`/Produto/AlteraVendeApp?produtoId=${produtoId}&vendeApp=${vendeApp}`);

export const alterarEsgotadoProduto = (produtoId, esgotado) =>
    putData(`/Produto/AlteraEsgotado?produtoId=${produtoId}&esgotado=${esgotado}`);

export const alterarInativoProduto = (produtoId, inativo) =>
    putData(`/Produto/AlteraInativo?produtoId=${produtoId}&inativo=${inativo}`);
